export default {
	banners(state) {
		return state.banners
	},
}
